// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/animate.min.css
// module id = OxAK
// module chunks = 88